module.exports = __webpack_public_path__ + "img/lock-sidebar.12b3f59f.svg";